import {
  Component, OnInit, TemplateRef, ViewChild, Output,
  EventEmitter,
} from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { interval } from 'rxjs';
import { Router } from '@angular/router';
import { SessionService } from '../../shared/services/session.service';
import { CookieService } from 'ngx-cookie-service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { userSessionConstants } from 'src/app/config/config';
import { OAuthService} from 'angular-oauth2-oidc';
import { EnvService } from 'src/app/core/services/env.service';
import { TranslateService } from '@ngx-translate/core';
import { InteractorService } from 'src/app/core/services/interactor.service';

@Component({
  selector: 'app-session-popup',
  templateUrl: './session-popup.component.html',
  styleUrls: ['./session-popup.component.scss']
})
export class SessionPopupComponent implements OnInit {
  modalRef: BsModalRef;
  @ViewChild('template') elementView: TemplateRef<any>;
  @Output() resetTimer = new EventEmitter<boolean>();
  secs: any;
  counter = 0;
  brandingDetails = JSON.parse(localStorage.getItem('branding'));
  btnDelete=this.brandingDetails?.branding?.BackgroundColors?.ConfirmDeleteBtnHover;
  constructor(
    private modalService: BsModalService,
    private sessionService: SessionService,
    private interactorService: InteractorService,
    public cookieService: CookieService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private oauthService: OAuthService,
    private envService: EnvService,
    private translatorService: TranslateService
    ) {
      this.translatorService.setDefaultLang('en');
      this.translatorService.use(localStorage.getItem('lang') || 'en');
    }

  ngOnInit(): void {
    this.interactorService.brandingDetailsCast.subscribe(data => {
      if (data) {
        this.brandingDetails = data;
        document.documentElement.style.setProperty('--btnDelete', this.brandingDetails?.branding?.BackgroundColors?.ConfirmDeleteBtnHover);
      }
      this.setBackgroundColors();
    });
    document.documentElement.style.setProperty('--btnDelete', this.brandingDetails?.branding?.BackgroundColors?.ConfirmDeleteBtnHover);

    this.sessionService.listenPopup().subscribe(item => {
      this.openModal();
   });

   this.sessionService.listenPopupClose().subscribe(item => {
    this.modalRef.hide();
    this.modalRef = undefined;
 });

   this.sessionService.listenTimer().subscribe(timer => {
   this.secs = new Date(timer.value * 1000).toISOString().substr(14, 5)
  });

  }

  public openModal() {
    if (!this.modalRef) {
      this.modalRef = this.modalService.show(this.elementView, {
        class: 'modal-dialog-centered',
        backdrop: 'static',
        keyboard: false
      });
    }

  }



  public sessionReset() {
    this.resetTimer.emit();
    this.modalRef.hide();
    this.modalRef = undefined;
  }

  public logout() {
    localStorage.setItem('isBrowserClosed', 'false');
    this.counter = 0;
    this.cookieService.deleteAll('');
    this.cookieService.deleteAll('/');
    this.cookieService.deleteAll('/', window.location.hostname);
    this.cookieService.deleteAll('/', 'https://' + window.location.hostname);
    this.localStorageService.deleteAllLocalStorage();
    const claims = this.oauthService.getIdentityClaims();
    this.oauthService.logOut(false);
    this.oauthService.revokeTokenAndLogout();
    this.resetTimer.emit();
    this.modalRef.hide();
    this.modalRef = undefined;
    window.location.href = this.envService.logoutUrl;
  }
  setBackgroundColors(){
    this.btnDelete=this.brandingDetails?.branding?.BackgroundColors?.ConfirmDeleteBtnHover;
  }

}
